module.exports = __webpack_public_path__ + "static/fonts/font.033d98a.eot";